import { formatarCentavos } from '@/pages/loja/utils';
import type { UltimaVenda } from '../types';

interface Props {
  venda: UltimaVenda;
  /** Caixa imprime fichas: mostra o botão Reimprimir. */
  imprime: boolean;
  /** Direção pode desfazer venda da maquininha. */
  direcao: boolean;
  aoReimprimir: () => void;
  aoDesfazer: () => void;
  aoFechar: () => void;
}

// Barra fina "última venda" no topo da tela de venda. Some ao começar a tocar
// em produtos ou depois de 60 s.
export default function BarraUltimaVenda({
  venda,
  imprime,
  direcao,
  aoReimprimir,
  aoDesfazer,
  aoFechar,
}: Props) {
  const podeDesfazer = venda.podeDesfazer || direcao;

  // Ficha que não saiu: barra vermelha que fica até reimprimir (não some ao tocar
  // em produtos nem depois de 60 s).
  if (venda.fichaPendente) {
    return (
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1 rounded-xl border border-danger-300 bg-danger-50 px-3 py-2">
        <span className="flex h-4 w-4 shrink-0 items-center justify-center text-danger-600">
          <i className="ri-printer-line" />
        </span>
        <span className="min-w-0 flex-1 truncate text-sm text-foreground-800">
          <span className="font-semibold">#{venda.numero}</span> ·{' '}
          <span className="font-semibold text-danger-700">ficha não saiu</span>
        </span>

        {imprime && (
          <button
            type="button"
            onClick={aoReimprimir}
            className="inline-flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap rounded-lg bg-danger-600 px-2.5 py-1.5 text-sm font-semibold text-white transition-colors hover:bg-danger-700"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-printer-line" />
            </span>
            Reimprimir
          </button>
        )}
        <button
          type="button"
          onClick={aoFechar}
          aria-label="Esconder"
          className="flex h-7 w-7 shrink-0 cursor-pointer items-center justify-center rounded-full text-foreground-400 transition-colors hover:bg-background-200"
        >
          <i className="ri-close-line" />
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-x-2 gap-y-1 rounded-xl border border-secondary-200 bg-background-50 px-3 py-2">
      <span className="flex h-4 w-4 shrink-0 items-center justify-center text-success-600">
        <i className="ri-checkbox-circle-line" />
      </span>
      <span className="min-w-0 flex-1 truncate text-sm text-foreground-800">
        <span className="font-semibold">#{venda.numero}</span> · {formatarCentavos(venda.total_centavos)}{' '}
        · {venda.metodoLabel}
        {imprime && venda.fichas > 0 && (
          <span className="text-secondary-500">
            {' '}
            · {venda.fichas} {venda.fichas === 1 ? 'ficha' : 'fichas'}
          </span>
        )}
      </span>

      {imprime && (
        <button
          type="button"
          onClick={aoReimprimir}
          className="inline-flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap rounded-lg border border-secondary-300 bg-white px-2.5 py-1.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
        >
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-printer-line" />
          </span>
          Reimprimir
        </button>
      )}
      {podeDesfazer && (
        <button
          type="button"
          onClick={aoDesfazer}
          className="shrink-0 cursor-pointer whitespace-nowrap rounded-lg border border-danger-200 bg-white px-2.5 py-1.5 text-sm font-medium text-danger-600 transition-colors hover:bg-danger-50"
        >
          Desfazer
        </button>
      )}
      <button
        type="button"
        onClick={aoFechar}
        aria-label="Esconder"
        className="flex h-7 w-7 shrink-0 cursor-pointer items-center justify-center rounded-full text-foreground-400 transition-colors hover:bg-background-200"
      >
        <i className="ri-close-line" />
      </button>
    </div>
  );
}